/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  new WOW().init()
  // 倒计时
  // 生成随机时间
  function generateRandomTime() {
    var hours = Math.floor(Math.random() * 15) + 1
    var minutes = Math.floor(Math.random() * 60)
    var seconds = Math.floor(Math.random() * 60)
    //总共的毫秒数
    var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

    return targetTime
  }
  function TimeDown(value) {
    //倒计时的总秒数
    var totalSeconds = parseInt(value / 1000)
    //取模（余数）
    var modulo = totalSeconds % (60 * 60 * 24)
    //小时数
    var hours = Math.floor(modulo / (60 * 60))
    modulo = modulo % (60 * 60)
    //分钟
    var minutes = Math.floor(modulo / 60)
    //秒
    var seconds = modulo % 60

    hours = hours.toString().length == 1 ? '0' + hours : hours
    minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
    seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

    //输出到页面
    $('.sp_hour').html(hours)
    $('.sp_minute').html(minutes)
    $('.sp_second').html(seconds)
    //延迟一秒执行自己
    if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
    } else {
      setTimeout(function () {
        TimeDown(value - 1000)
      }, 1000)
    }
  }
  TimeDown(generateRandomTime())
  let spImgList = []
  new Swiper('.mySwiperWord', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    loop: true,
    speed: 2000,
  })
  new Swiper('.sp-swiper-fade', {
    // spaceBetween: 10,
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  })

  new Swiper('.sp-swiper-fade1', {
    slidesPerView: 'auto',
    spaceBetween: 21,
    centeredSlides: true,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  new Swiper('.sp-swiper-fade2', {
    slidesPerView: 3,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  new Swiper('.sp-swiper1', {
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 49,
    centeredSlides: true,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  new Swiper('.sp-swiper-scroll1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    loop: true,
  })
  new Swiper('.sp-swiper-scroll2', {
    slidesPerView: 'auto',
    spaceBetween: 53,
    centeredSlides: true,
    loop: true, //循环滚动
    freeMode: true,
    speed: 5500, //匀速时间
    autoplay: {
      delay: 3000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  jQuery('.sp-scroll').slide({
    mainCell: '.nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 1,
    scroll: 1,
  })
  jQuery('.sp-scroll2').slide({
    mainCell: '.nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 1,
    scroll: 1,
  })
  $('.product-box .sp-opt').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    let _index = $(this).index()

    $(this)
      .parents('.product-box')
      .find('.sp-p-img')
      .eq([_index])
      .show()
      .siblings('.sp-p-img')
      .hide()
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let sptop =
          document.body.clientWidth <= 1080
            ? $('.sp-mobile .sp-fixed-top').height()
            : $('.sp-pc .sp-fixed-top').height()
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        })
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  let sp_price1 = 19.99
  let sp_price2 = 39.99

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(2)
  }
  let prods = window.product
  function getCur1() {
    let color = $('.sp-mobile #color div.active').attr('data-val')
    let volume = $('.sp-mobile #volume div.active').attr('data-val')
    let Size = $('.sp-mobile #Size div.active').attr('data-val')
    return prods.filter(
      item => item.option1 == color && item.option2 == volume && item.option3 == Size
    )[0]
  }
  function getCur2() {
    let color = $('.sp-pc #color2 div.active').attr('data-val')
    let volume = $('.sp-pc #volume2 div.active').attr('data-val')
    let Size = $('.sp-pc #Size2 div.active').attr('data-val')
    return prods.filter(
      item => item.option1 == color && item.option2 == volume && item.option3 == Size
    )[0]
  }
  function changePrice1() {
    let num = $('.sp-mobile #calcNumber').val()
    let price = ((getCur1().price * num) / 100).toFixed(2)
    let compare = ((getCur1().compare_at_price * num) / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('.sp-mobile #new').html(price)
    $('.sp-mobile #old').html(compare)

    let off_font =
      100 - Math.ceil((getCur1().price / getCur1().compare_at_price) * 100)
    $('.sp-mobile.product-part .product-infos .off-font').html(off_font)
  }
  function changePrice2() {
    let num = $('.sp-pc #calcNumber').val()
    let price = ((getCur2().price * num) / 100).toFixed(2)
    let compare = ((getCur2().compare_at_price * num) / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('.sp-pc #sp_price3').html(price)
    $('.sp-pc #sp_price4').html(compare)

    let off_font =
      100 - Math.ceil((getCur2().price / getCur2().compare_at_price) * 100)
    $('.sp-pc.product-part .product-infos .off-font').html(off_font)
  }
  $('.sp-mobile .sp-btn-style').click(function () {
    let num = $('.sp-mobile #calcNumber').val()
    window.location.href = '/cart/' + getCur1().id + ':' + num
  })
  $('.sp-pc .sp-btn-style').click(function () {
    let num = $('.sp-pc #calcNumber').val()
    window.location.href = '/cart/' + getCur2().id + ':' + num
  })
  $('.sp-mobile .reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    changePrice1()
  })
  $('.sp-mobile .add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice1()
  })

  $('.sp-pc .reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    changePrice2()
  })
  $('.sp-pc .add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice2()
  })
  $('.sp-pc .product-box').click(function () {
    $(this).addClass('sp-active').siblings().removeClass('sp-active')
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }
  // 产品切换
  var _index = 0
  $('.opt-group .option').click(function () {
    $(this).addClass('active').siblings().removeClass('active')
  })
  $('#color .option').click(function () {
    var index = $(this).index()
    var index2 = $('#volume .option.active').index()
    var index3 = $('#Size .option.active').index()
    changeoption(index, index3, index2)
    changePrice1()
  })
  $('#color2 .option').click(function () {
    var index = $(this).index()
    var index2 = $('#volume2 .option.active').index()
    var index3 = $('#Size2 .option.active').index()
    changeoption(index, index3, index2)
    changePrice2()
  })
  $('#volume .option').click(function () {
    var index = $('#color .option.active').index()
    var index2 = $(this).index()
    var index3 = $('#Size .option.active').index()
    changeoption(index, index3, index2)
    changePrice1()
  })
  $('#volume2 .option').click(function () {
    var index = $('#color2 .option.active').index()
    var index2 = $(this).index()
    var index3 = $('#Size2 .option.active').index()
    changeoption(index, index3, index2)
    changePrice2()
  })
  $('#Size .option').click(function () {
    var index = $('#color .option.active').index()
    var index2 = $('#volume .option.active').index()
    var index3 = $(this).index()
    changeoption(index, index3, index2)
    changePrice1()
  })
  $('#Size2 .option').click(function () {
    var index = $('#color2 .option.active').index()
    var index2 = $('#volume2 .option.active').index()
    var index3 = $(this).index()
    changeoption(index, index3, index2)
    changePrice2()
  })
  function changeoption(index, index2, index3) {
    console.log(index, index2, index3);
    
    $('.sp-mobile .sp-tops-img>img').hide()
    $('.sp-pc .sp-tops-img>img').hide()
    if (index2 == 0) {
      $('.sp-pro-tags').show()
      $('.sp-pro-free').hide()
      $('.sp-pro-colors').hide()
      if (index3 == 0) {
        $('.sp-mobile .sp-tops-img>img').eq(index).show()
        $('.sp-pc .sp-tops-img>img').eq(index).show()
        $('.sp-pro-tags').html('Net weight:200g')
        $('.sp-pro-tags').css('right','65px');
        $('.sp-pro-tags').css('left','unset');
      } else if (index3 == 1) {
        $('.sp-mobile .sp-tops-img>img').eq(index).show()
        $('.sp-pc .sp-tops-img>img').eq(index).show()
        $('.sp-pro-tags').html('Net weight:500g')
        $('.sp-pro-tags').css('right','65px');
        $('.sp-pro-tags').css('left','unset');
      } else if (index3 == 2){
        $('.sp-mobile .sp-tops-img>img').eq(index + 5).show()
        $('.sp-pc .sp-tops-img>img').eq(index + 5).show()
        $('.sp-pro-tags').html('Net weight:200g')
        $('.sp-pro-tags').css('left','65px');
        $('.sp-pro-tags').css('right','unset');
      }else{
        $('.sp-mobile .sp-tops-img>img').eq(index + 5).show()
        $('.sp-pc .sp-tops-img>img').eq(index + 5).show()
        $('.sp-pro-tags').html('Net weight:500g')
        $('.sp-pro-tags').css('left','65px');
        $('.sp-pro-tags').css('right','unset');
      }
      _index = index
    } else if (index2 == 1) {
      $('.sp-pro-tags').hide()
      $('.sp-pro-colors').css('display', 'flex')
      if (index3 == 0) {
        $('.sp-mobile .sp-tops-img>img').eq(3).show()
        $('.sp-pc .sp-tops-img>img').eq(3).show()
        $('.sp-is-tag').html('200g')
        $('.sp-pro-tags').css('right','65px');
        $('.sp-pro-tags').css('left','unset');
        $('.sp-pro-free').show()
      } else if (index3 == 1) {
        $('.sp-mobile .sp-tops-img>img').eq(3).show()
        $('.sp-pc .sp-tops-img>img').eq(3).show()
        $('.sp-is-tag').html('500g')
        $('.sp-pro-tags').css('right','65px');
        $('.sp-pro-tags').css('left','unset');
        $('.sp-pro-free').show()
      } else if (index3 == 2){
        $('.sp-mobile .sp-tops-img>img').eq(8).show()
        $('.sp-pc .sp-tops-img>img').eq(8).show()
        $('.sp-is-tag').html('200g')
        $('.sp-pro-tags').css('left','65px');
        $('.sp-pro-tags').css('right','unset');
        $('.sp-pro-free').hide()
      }else{
        $('.sp-mobile .sp-tops-img>img').eq(8).show()
        $('.sp-pc .sp-tops-img>img').eq(8).show()
        $('.sp-is-tag').html('500g')
        $('.sp-pro-tags').css('left','65px');
        $('.sp-pro-tags').css('right','unset');
        $('.sp-pro-free').hide()
      }
      if (index == 0) {
        $('.sp-is').css('background', '#ffffff')
        $('.sp-is-text').html('White')
      } else if (index == 1) {
        $('.sp-is').css('background', '#bcbcbc')
        $('.sp-is-text').html('Gray')
      } else {
        $('.sp-is').css('background', '#000000')
        $('.sp-is-text').html('Black')
      }
      _index = 3
    } else if (index2 == 2) {
      $('.sp-pro-tags').hide()
      $('.sp-pro-colors').css('display', 'flex')
      if (index3 == 0) {
        $('.sp-mobile .sp-tops-img>img').eq(4).show()
        $('.sp-pc .sp-tops-img>img').eq(4).show()
        $('.sp-is-tag').html('200g')
        $('.sp-pro-tags').css('right','65px');
        $('.sp-pro-free').show()
      } else if (index3 == 2) {
        $('.sp-mobile .sp-tops-img>img').eq(4).show()
        $('.sp-pc .sp-tops-img>img').eq(4).show()
        $('.sp-is-tag').html('500g')
        $('.sp-pro-tags').css('right','65px');
        $('.sp-pro-free').show()
      } else if (index3 == 1){
        $('.sp-mobile .sp-tops-img>img').eq(4).show()
        $('.sp-pc .sp-tops-img>img').eq(4).show()
        $('.sp-is-tag').html('500g')
        $('.sp-pro-tags').css('left','65px');
        $('.sp-pro-free').show()
      }else{
        $('.sp-mobile .sp-tops-img>img').eq(4).show()
        $('.sp-pc .sp-tops-img>img').eq(4).show()
        $('.sp-is-tag').html('500g')
        $('.sp-pro-tags').css('left','65px');
        $('.sp-pro-free').hide()
      }
      if (index == 0) {
        $('.sp-is').css('background', '#ffffff')
        $('.sp-is-text').html('White')
      } else if (index == 1) {
        $('.sp-is').css('background', '#bcbcbc')
        $('.sp-is-text').html('Gray')
      } else {
        $('.sp-is').css('background', '#000000')
        $('.sp-is-text').html('Black')
      }
      _index = 4
    }
  }
  // function changeoption(index, index3, index2) {
  //   $('.sp-mobile .sp-tops-img>img').hide()
  //   $('.sp-pc .sp-tops-img>img').hide()
  //   if (index3 == 0) {
  //     $('.sp-mobile .sp-tops-img>img').eq(index).show()
  //     $('.sp-pc .sp-tops-img>img').eq(index).show()
  //     $('.sp-pro-tags').show()
  //     $('.sp-pro-free').hide()
  //     $('.sp-pro-colors').hide()
  //     if (index2 == 0) {
  //       $('.sp-pro-tags').html('Net weight:200g')
  //     } else if (index2 == 1) {
  //       $('.sp-pro-tags').html('Net weight:500g')
  //     }
  //     _index = index
  //   } else if (index3 == 1) {
  //     $('.sp-mobile .sp-tops-img>img').eq(3).show()
  //     $('.sp-pc .sp-tops-img>img').eq(3).show()
  //     $('.sp-pro-tags').hide()
  //     $('.sp-pro-free').show()
  //     $('.sp-pro-colors').css('display', 'flex')
  //     if (index2 == 0) {
  //       $('.sp-is-tag').html('200g')
  //     } else if (index2 == 1) {
  //       $('.sp-is-tag').html('500g')
  //     }
  //     if (index == 0) {
  //       $('.sp-is').css('background', '#ffffff')
  //       $('.sp-is-text').html('White')
  //     } else if (index == 1) {
  //       $('.sp-is').css('background', '#bcbcbc')
  //       $('.sp-is-text').html('Gray')
  //     } else {
  //       $('.sp-is').css('background', '#000000')
  //       $('.sp-is-text').html('Black')
  //     }
  //     _index = 3
  //   } else if (index3 == 2) {
  //     $('.sp-mobile .sp-tops-img>img').eq(4).show()
  //     $('.sp-pc .sp-tops-img>img').eq(4).show()
  //     $('.sp-pro-tags').hide()
  //     $('.sp-pro-free').show()
  //     $('.sp-pro-colors').css('display', 'flex')
  //     if (index2 == 0) {
  //       $('.sp-is-tag').html('200g')
  //     } else if (index2 == 1) {
  //       $('.sp-is-tag').html('500g')
  //     }
  //     if (index == 0) {
  //       $('.sp-is').css('background', '#ffffff')
  //       $('.sp-is-text').html('White')
  //     } else if (index == 1) {
  //       $('.sp-is').css('background', '#bcbcbc')
  //       $('.sp-is-text').html('Gray')
  //     } else {
  //       $('.sp-is').css('background', '#000000')
  //       $('.sp-is-text').html('Black')
  //     }
  //     _index = 4
  //   }
  // }
  function checkDeviceType() {
    const isMobile = window.matchMedia('(max-width: 1080px)').matches
    return isMobile ? true : false
  }
  // 加入购物车
  addCart()
  function addCart() {
    // 加入购物车
    $('.addCerts').click(function () {
      // do something here
      let isPC = $(this).closest('.product-part').hasClass('sp-pc')
      var data = {
        id: getCur1().id,
        quantity: isPC? $('.sp-pc #calcNumber').val() : $('.sp-mobile #calcNumber').val(),
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('.sp-cart #cardNum').html(result.item_count)
            if (result.item_count > 0) {
                $('.sp-cart .num').css('background', '#cf0101')
            } else {
                $('.sp-cart .num').css('background', '#919191')
            }
          })
        },
        dataType: 'json',
      })
      var img = $('.sp-tops-img>img').eq(_index)
      if ($(this).closest('.product-part').hasClass('sp-pc')) {
        img = $('.sp-pc .sp-tops-img>img').eq(_index)
      } else {
        img = $('.sp-mobile .sp-tops-img>img').eq(_index)
      }
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('clone')
      $('.product-part').append(flyer)
      $('.clone').css({
        width: img.width(),
        height: img.height(),
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })
      var offset = $('.sp-cart')[0].getBoundingClientRect()
      $('.sp-cart').addClass('shake')
      setTimeout(() => {
        $('.sp-cart').removeClass('shake')
      }, 1000)
      var finish
      if (checkDeviceType()) {
        finish = $('.sp-cart')[0]
      } else {
        finish = $('.sp-cart')[1]
      }
      $('.clone').animate(
        {
          top: finish.offsetTop,
          left: finish.offsetLeft + $('.sp-cart').width() / 2 - 15,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        1000,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach() // 完成动画后移除克隆的图片
            }
          )
        }
      )
    })
  }

  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $('.sp-header').height() * $('div#root').css('zoom')
  ) {
    $('.sp-fixed-top').addClass('sp-fixed')
  } else {
    $('.sp-fixed-top').removeClass('sp-fixed')
  }

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $('.sp-header').height() * $('div#root').css('zoom')
    ) {
      $('.sp-fixed-top').addClass('sp-fixed')
    } else {
      $('.sp-fixed-top').removeClass('sp-fixed')
    }
  })

  // 问答
  $('.q-row').click(function () {
    $(this).parent().toggleClass('sp-show')
  })

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }
})
